module.exports = __webpack_public_path__ + "img/banner.b747f91b.png";